import React from 'react';
import { Route } from 'react-router-dom';
import ContainerRoute from './ContainerRoute'

import ProfessorRoute from "./ProfessorRoute";

import Account from '../pages/MP/PIM/Account';
import AccountCheck from '../pages/MP/PIM/AccountCheck';

import MyCourses from '../pages/MP/GME/List'
import MyCoursesView from '../pages/MP/GME/View';

import MyInquiry from '../pages/MP/INF/List';
import MyInquiryView from '../pages/MP/INF/View';
import MyInquiryWrite from '../pages/MP/INF/Write';

import MyInterested from '../pages/MP/INC/MyInterested';
import MyViewed from '../pages/MP/VWC/MyViewed';

// import VLabLecture from '../pages/MP/CTS/LectureList';//'./contents/lecture/List'
// import VLabLectureView from '../pages/MP/CTS/LectureView';//'./contents/lecture/View'
// import XRContents from '../pages/MP/CTS/XrList';//'./contents/xr/List'
// import XRContentsView from '../pages/MP/CTS/XrView';//'./contents/xr/View'

import MyManagement from '../pages/MP/PME/List';
import MyManagementView from '../pages/MP/PME/View';
// import NotFound from '../pages/n';
import MyQna from '../pages/MP/PME/QnaList';
import MyQnaView from '../pages/MP/PME/QnaView';

import ProtectedRoute from './ProtectedRoute';

const MypageRoutes = () => (
  <>
    {/* 교수자 외 일반적인 로그인 상태인 경우 */}
    <Route element={<ProtectedRoute />}>
      {/* 내정보관리 */}
      {ContainerRoute('/mypage/account', <Account />)}
      {ContainerRoute('/mypage/account/account-check', <AccountCheck />)}

      {/* 나의 수강강좌 */}
      {ContainerRoute('/mypage/courses', <MyCourses />)}
      {ContainerRoute('/mypage/courses/:id', <MyCoursesView />)}

      {/* 나의 문의 */}
      {ContainerRoute('/mypage/inquiry', <MyInquiry />)}
      {ContainerRoute('/mypage/inquiry/write', <MyInquiryWrite />)}
      {ContainerRoute('/mypage/inquiry/:id', <MyInquiryView />)}

      {/* 콘텐츠 관련 - 확인중 */}
      {ContainerRoute('/mypage/interested', <MyInterested />)}
      {ContainerRoute('/mypage/viewed', <MyViewed />)}
      {/* <Route key="/mypage/viewed" path="/mypage/viewed" element={withContainer('/mypage/viewed', <MyViewed />)} />, */}
    </Route>
    {/* 교수자인경우에만 접근할 수 있도록 처리 */}
    <Route element={<ProtectedRoute allow={['PROFESSOR']} />}>
      {/* 강좌관리 */}
      {ContainerRoute('/mypage/management', <ProfessorRoute><MyManagement /></ProfessorRoute>)}
      {ContainerRoute('/mypage/management/:id', <ProfessorRoute><MyManagementView /></ProfessorRoute>)}

      {/* QNA관리 */}
      {ContainerRoute('/mypage/qna', <ProfessorRoute><MyQna /></ProfessorRoute>)}
      {ContainerRoute('/mypage/qna/:id', <ProfessorRoute><MyQnaView /></ProfessorRoute>)}
    </Route>      

  </>
);

export default MypageRoutes;